import React from 'react';
import { NavigationProps } from '../types/navigation';
import { Button } from '../components/ui/Button';
import { motion } from 'framer-motion';
import { Sparkles, Truck, Gamepad2 } from 'lucide-react';
/**
 * Virtual Fishing — a teaser for a future feature. We intentionally do NOT
 * reveal the unlock threshold; everyone simply sees that it's coming later, so
 * the mechanic stays a surprise and nobody feels gated by a visible number.
 */
export function GoFishPage({
  onNavigate
}: NavigationProps) {
  return <div className="min-h-screen bg-brand-blue flex flex-col items-center justify-center p-6 text-center relative overflow-hidden pb-24" data-id="element-2118" data-mp="2kb03t0bvuoku">
      <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-2119" data-mp="2objzdzgt5k4v" />

      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="relative z-10 bg-white p-8 rounded-3xl border-2 border-brand-blue/10 max-w-sm w-full shadow-xl" data-id="element-2120" data-mp="tzn5lzuw826n">
        <motion.div initial={{
        scale: 0.8
      }} animate={{
        scale: 1
      }} transition={{
        delay: 0.1,
        type: 'spring',
        stiffness: 200
      }} className="w-20 h-20 bg-brand-yellow/20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-2121" data-mp="17nuwa7pi108x">
          <Gamepad2 className="w-10 h-10 text-brand-blue" data-id="element-2122" data-mp="1re6n1q69g7or" />
        </motion.div>

        <span className="inline-flex items-center gap-1.5 bg-brand-blue/10 text-brand-blue text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-3" data-id="element-2123" data-mp="1mdiwf5ly1sv2">
          <Sparkles className="w-3.5 h-3.5" data-id="element-2124" data-mp="1hhbpb9htabbj" />
          Coming later
        </span>

        <h1 className="text-3xl font-display text-brand-blue uppercase tracking-wide mb-3" data-id="element-2125" data-mp="b06rereg747b">
          Virtual Fishing
        </h1>
        <p className="text-gray-600 mb-6 font-medium leading-relaxed" data-id="element-2126" data-mp="7gy3h2rgkgyt">
          A brand-new way to play is on the way. Soon you'll be able to cast a
          line virtually, catch real products anywhere, and get them delivered.
          Stay tuned — it's coming as a future feature.
        </p>

        <div className="bg-brand-light p-4 rounded-xl border border-brand-blue/10 mb-6 text-left" data-id="element-2127" data-mp="3fco9argbqlg">
          <h3 className="text-brand-blue font-bold mb-1 flex items-center" data-id="element-2128" data-mp="3kw48s7w819l3">
            <Truck className="w-4 h-4 mr-2 text-brand-blue" data-id="element-2129" data-mp="3ktrk7bvyk0z2" />
            What to expect
          </h3>
          <p className="text-sm text-gray-600" data-id="element-2130" data-mp="3pof93buvixe6">
            Catch products from anywhere and have them{' '}
            <strong data-id="element-2131" data-mp="3fwrbet7q4k49">delivered to your door</strong> or picked up flexibly. Keep
            catching and reviewing in the meantime!
          </p>
        </div>

        <Button onClick={() => onNavigate('feed')} className="w-full" data-id="element-2132" data-mp="31xi7arwslggn">
          Back to Feed
        </Button>
      </motion.div>
    </div>;
}